import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ACMEListResponse, TODO, UIBModalService } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, ILogService, ISCEService, IScope } from 'angular';
import moment from 'moment-timezone';
import { TemplatesCreateSchedulesControllerModule } from '../../../../templates/create/schedules/controllers/TemplatesCreateSchedulesController';

export const ProgramsDetailOverviewControllerModule = angular
  .module('acme.view.application.programs.detail.overview.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.calendar',
    'acme.common.service.helpers',
    'acme.common.service.templates',
    'acme.common.service.userPreferences',
    'acme.common.service.permissions',
    'acme.common.service.feature',
    'acme.common.service.themesHelper',
    TemplatesCreateSchedulesControllerModule,
  ])
  .controller('ProgramsDetailOverviewController', [
    '$scope',
    '$sce',
    '$state',
    '$log',
    '$uibModal',
    '$filter',
    'ResolveViewData',
    'ApiService',
    'CalendarService',
    'HelpersService',
    'TemplatesService',
    'UserPreferencesService',
    'PermissionsService',
    'ThemesHelperService',
    function ProgramsDetailOverviewController(
      $scope: IScope & { programsDetailOverview: TODO; safeDescription: TODO; pricingGridOptions: TODO },
      $sce: ISCEService,
      $state: StateService,
      $log: ILogService,
      $uibModal: UIBModalService,
      $filter: IFilterService,
      ResolveViewData: TODO,
      ApiService: ApiService,
      CalendarService: TODO,
      HelpersService: TODO,
      TemplatesService: TODO,
      UserPreferencesService: TODO,
      PermissionsService: PermissionsService,
      ThemesHelperService: ThemesHelperService
    ) {
      const CONSTANTS = {
        RESTRICT: {
          TOOLTIP: 'Specify the list of valid memberships by creating Rules.\n\nDiscounts and limits are optional.',
          NONE: 'Only some membership levels can purchase admission (Rules below define list of levels)',
          ALL: 'None. All members can purchase admission.',
        },
      };

      $scope.programsDetailOverview = {
        CONSTANTS: CONSTANTS,
        hasAccountDiscounts: false,
        hasCouponDiscounts: false,
        hasMemberRules: false,
        hasSalesRules: false,
        hasTicketsRules: false,
        hasAppliedAddOns: false,
        model: {},

        primaryPhoto: {},
        membershipLevelsLoaded: false,
        safeDescription: '',
        shortDescriptionMax: 300,
        restrictMembers: false,
        accountDiscounts: [],
        filterDiscount: '',
        timeFrames: [
          {
            label: 'Per Day',
            name: 'day',
          },
          {
            label: 'Per Event',
            name: 'lifetime',
          },
          {
            label: 'Per Event Instance',
            name: 'instance',
          },
          {
            label: 'Per Order',
            name: 'order',
          },
        ],
        limitTypes: [
          {
            label: 'Each',
            name: 'forEachItem',
          },
          {
            label: 'Across',
            name: 'acrossAllItems',
          },
        ],
        discountFilters: [
          {
            label: 'All Rules',
            name: '',
          },
          {
            label: 'Rules without discounts and limits',
            name: 'norules',
          },
          {
            label: 'Rules with discounts and limits',
            name: 'both',
          },
          {
            label: 'Rules with only discounts (no limits)',
            name: 'discounts',
          },
          {
            label: 'Rules with only limits (no discounts)',
            name: 'limits',
          },
        ],
        salesRuleTypes: [
          {
            label: 'Limit sales of',
            name: 'limit',
          },
          {
            label: 'Prevent sales of',
            name: 'prevent',
          },
        ],
        couponDiscounts: [],
        memberRules: [],
        salesRules: [],
        ticketsRules: [],
        appliedAddOns: [],
        membershipLevels: {},
        currentTab: 'description',
        currentPricingTab: 'general',
        dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),
        hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
        admissionTypes: [
          {
            label: 'Standard',
            name: 'standard',
          },
          {
            label: 'General Admission',
            name: 'generalAdmission',
          },
        ],

        cap: HelpersService.cap,
        strip: HelpersService.strip,

        componentType: 'eventTemplate',

        init: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Event Template',
            buttonRight: {
              label: 'Edit Template',
              permissions: 'EVENT_TEMPLATE_UPDATE',
              action: function () {
                $state.go('application.templates.edit.description', { id: $scope.programsDetailOverview.model.id });
              },
            },
          });

          if (ResolveViewData.data && ResolveViewData.data.success) {
            this.success.init(ResolveViewData);
          } else {
            this.error.init(ResolveViewData);
          }

          this.getAppliedDiscounts();

          this.getCouponDiscounts();
        },

        getAppliedDiscounts: function () {
          ApiService.partners.templates
            .detail(this.model.id)
            .then(this.success.getAppliedDiscounts, this.error.getAppliedDiscounts);
        },

        getCouponDiscounts: function () {
          ApiService.coupons.templates
            .detail(this.model.id)
            .then(this.success.getCouponDiscounts, this.error.getCouponDiscounts);
        },

        getMembershipDiscounts: function () {
          const self = $scope.programsDetailOverview;

          this.membershipLevelsLoaded = false;
          ApiService.program.entitlements
            .list(this.model.id)
            .then((response) => {
              self.success.getMembershipDiscounts(response);
              self.success.getSalesRules(response);
              self.success.getTicketsRules(response);
            })
            .catch((response) => {
              self.error.getMembershipDiscounts(response);
              self.error.getSalesRules(response);
              self.error.getTicketsRules(response);
            });
        },

        getScheduleTime: function (time: TODO) {
          return moment({ hours: time.hour, minutes: time.minutes }).format(this.hourFormat);
        },

        selectMembershipLevels: function (allMembershipHash: TODO, memberships: TODO[]) {
          return memberships
            .map((membership) => {
              const membershipFound = allMembershipHash[membership.id];

              return membershipFound && Object.assign({}, membershipFound);
            })
            .filter((membership) => membership);
        },

        getMembershipLevels: function () {
          const props = HelpersService.getPaginator();

          props.isPublished = 1;
          return ApiService.membership
            .categoriesList(props)
            .then(this.processMembershipLevels.bind(this))
            .then(this.setMembershipLevels.bind(this))
            .catch(this.setMembershipLevels.bind(this));
        },

        setMembershipLevels: function (memberships) {
          this.membershipLevels = memberships;
          return memberships;
        },

        _orderByBusinessRules: function (a, b) {
          const displayNameA = a.displayName || a.name || '';
          const displayNameB = b.displayName || b.name || '';

          return displayNameA.toUpperCase() > displayNameB.toUpperCase() ? 1 : -1;
        },

        processMembershipLevels: function (response: { data: ACMEListResponse<TODO> }) {
          const memberships = response?.data?.payload?.list ?? [];

          return memberships
            .map((membership) => {
              const isAux = membership.auxiliary && membership.membershipLevelCollection;
              const auxName = isAux && [membership.membershipLevelCollection[0].name, membership.name].join(' - ');
              const displayName = isAux ? auxName : membership.name;

              membership = Object.assign({}, membership, {
                displayName: displayName,
                displayOrder: isAux ? 1 : 0,
              });

              return membership;
            })
            .sort(this._orderByBusinessRules)
            .reduce((hash, membership) => {
              hash[membership.id] = membership;

              return hash;
            }, {});
        },

        getWeekdays: function (weekdays) {
          let days = '';

          for (let i = 0, ii = weekdays.length; i < ii; i++) {
            if (i > 0) {
              if (i === ii - 1) {
                days += ', and ';
              } else if (i <= ii - 2) {
                days += ', ';
              }
            }
            days += CalendarService.weekdays[weekdays[i]].name;
          }

          return days;
        },

        checkPermission: function (permission) {
          return PermissionsService.check(permission);
        },

        hasSaleRestrictions: function (index) {
          return (
            this.model.schedules[index].salesRestrictions instanceof Array &&
            this.model.schedules[index].salesRestrictions.length > 0
          );
        },

        hasTicketPrintLines: function () {
          let lines = '';

          if (this.model.ticketDetails && this.model.ticketDetails.ticketPrintLines instanceof Array) {
            lines =
              (this.model.ticketDetails.ticketPrintLines[0] || '') +
              (this.model.ticketDetails.ticketPrintLines[1] || '') +
              (this.model.ticketDetails.ticketPrintLines[2] || '') +
              (this.model.ticketDetails.ticketPrintLines[3] || '');
            return lines.length > 0;
          }
        },

        isTab: function (tab) {
          return tab === this.currentTab;
        },

        getTab: function (tab) {
          this.currentTab = tab;
        },

        isPricingTab: function (tab) {
          return tab === this.currentPricingTab;
        },

        getPricingTab: function (tab) {
          this.currentPricingTab = tab;
        },

        isAdmissionType: function (type) {
          return this.model.admissionType === type;
        },

        findAdmissionType: function (name) {
          for (let i = 0, ii = this.admissionTypes.length; i < ii; i++) {
            if (this.admissionTypes[i].name === name) {
              return this.admissionTypes[i];
            }
          }

          return false;
        },

        getChannelLabel: function (name: string) {
          switch (name) {
            case 'online':
              return 'Web';

            default:
              return 'Web';
          }
        },

        getScheduleStartDate: function () {
          return this.getEth($filter('date')(this.model.startTime, 'd'));
        },

        getScheduleEndDate: function () {
          return this.getEth($filter('date')(this.model.endTime, 'd'));
        },

        hasPriceLists: function () {
          return this.model.priceLists && this.model.priceLists[0].prices.length > 0;
        },

        checkAccountDiscounts: function () {
          this.hasAccountDiscounts = this.accountDiscounts instanceof Array && this.accountDiscounts.length > 0;
        },

        checkCouponDiscounts: function () {
          this.hasCouponDiscounts = this.couponDiscounts instanceof Array && this.couponDiscounts.length > 0;
        },

        checkMemberDiscounts: function () {
          this.hasMemberRules = this.memberRules instanceof Array && this.memberRules.length > 0;
        },

        checkTicketsRules: function () {
          this.hasTicketsRules = this.ticketsRules instanceof Array && this.ticketsRules.length > 0;
        },

        checkSalesRules: function () {
          this.hasSalesRules = this.salesRules instanceof Array && this.salesRules.length > 0;
        },

        isEnableSalesRules: function () {
          return ThemesHelperService.getCompany('enableSalesView');
        },

        showAccounts: function (accountCategoryId) {
          const self = $scope.programsDetailOverview;

          self.addModal = $uibModal.open({
            templateUrl: 'views/application/views/programs/create/modals/showAccountsModal.tpl.html',
            size: 'md',
            controller: 'ProgramsCreateShowAccountsModalController',
            resolve: {
              AccountsListData: () => ApiService.partners.categories.detail(accountCategoryId),
            },
          });

          // Invoked when modal completes with close(params)
          self.addModal.result
            .then(() => {
              // noop
            })
            .catch(() => {
              // noop
            });
        },

        schedulesGridDoubleClick: function (row) {
          $state.go('application.templates.edit.schedules.edit.times', {
            id: $state.params.id,
            scheduleId: row.entity.id,
          });
        },

        success: {
          init: function (response, status, headers, config) {
            const self = $scope.programsDetailOverview;

            if (!response.data.payload) {
              return;
            }

            TemplatesService.resetModel();

            TemplatesService.setModel(response.data.payload);

            self.model = TemplatesService.getModel();

            self.safeDescription = $sce.trustAsHtml(self.model.description);
            console.log(
              'ProgramsDetailController::success',
              self.model,
              $scope.safeDescription,
              response.data.payload.description
            );

            if (self.model.images instanceof Array) {
              for (let i = 0, ii = self.model.images.length; i < ii; i++) {
                if (self.model.images[i].primary) {
                  self.primaryPhoto = self.model.images[i];
                  break;
                }
              }
            }

            if (!(self.model.emailNotify instanceof Array)) {
              self.model.emailNotify = [];
            }

            if (!(self.model.onlinePaymentsForOrgOrdersEmailNotify instanceof Array)) {
              self.model.onlinePaymentsForOrgOrdersEmailNotify = [];
            }

            if (self.model.priceLists instanceof Array && self.model.priceLists.length > 0) {
              self.model.priceLists[0] = TemplatesService.processSalesChannels(self.model.priceLists[0]);
            }

            self.hasAppliedAddOns =
              self.model.addOns != null &&
              self.model.addOns.inventoryAddOns != null &&
              self.model.addOns.inventoryAddOns instanceof Array &&
              self.model.addOns.inventoryAddOns.length > 0;

            self.getMembershipLevels().then(self.getMembershipDiscounts.bind(self));
          },

          getAppliedDiscounts: function (response) {
            $scope.programsDetailOverview.accountDiscounts = response.data.payload;
            $scope.programsDetailOverview.checkAccountDiscounts();
          },

          getCouponDiscounts: function (response) {
            $scope.programsDetailOverview.couponDiscounts = response.data.payload;
            $scope.programsDetailOverview.checkCouponDiscounts();
          },

          getMembershipDiscounts: function (response) {
            const self = $scope.programsDetailOverview;

            self.membershipLevelsLoaded = true;
            self.model.membership = response.data.payload;
            const savedMemberDiscounts = (self.model.membership && self.model.membership.entitlementConfig) || [];
            savedMemberDiscounts.forEach(function (savedMemberDiscount) {
              const discountCodes = savedMemberDiscount.discountCodes;
              const discount = (discountCodes && discountCodes.discountCodeInfo[0]) || null;
              const pricepoints = savedMemberDiscount.pricepoints || {};
              const ruleTimeFrame = savedMemberDiscount.timeFrame || {};
              const membershipLevels = savedMemberDiscount.membershipLevels || {};

              const hasPricePoints =
                pricepoints && pricepoints.pricepointInfo instanceof Array && pricepoints.pricepointInfo.length;

              self.memberRules.push({
                membershipCategories: self.selectMembershipLevels(
                  self.membershipLevels || {},
                  membershipLevels.membershipLevelInfo || []
                ),
                discountCode: discount,
                timeFrame:
                  self.timeFrames.find((timeFrame) => timeFrame.name === ruleTimeFrame.period) || self.timeFrames[0],
                limitType:
                  self.limitTypes.find((limitType) => limitType.name === membershipLevels.ruleApplies) ||
                  self.limitTypes[0],
                quantity: hasPricePoints ? savedMemberDiscount.quantity : '',
                pricepoints: hasPricePoints ? pricepoints.pricepointInfo.sort(self._orderByBusinessRules) : [],
                _errors: [],
                _showLimitButton: !(discount || hasPricePoints),
              });
            });

            self.checkMemberDiscounts();
          },

          getTicketsRules: function (response) {
            const self = $scope.programsDetailOverview;

            const ticketsRules = (response.data.payload && response.data.payload.ticketRuleConfig) || [];
            ticketsRules.forEach(function (rule) {
              const pricepoints = rule.pricepoints || {};

              const hasPricePoints =
                pricepoints && Array.isArray(pricepoints.pricepointInfo) && pricepoints.pricepointInfo.length > 0;

              rule.salesRuleType = {
                label: 'Limit sales of',
                name: 'limit',
              };

              self.ticketsRules.push({
                timeFrame: self.timeFrames[3],
                limitType: self.limitTypes[1],
                salesRuleType: rule.salesRuleType,
                quantity: rule.quantity || '0',
                pricepoints: hasPricePoints ? pricepoints.pricepointInfo.sort(self._orderByBusinessRules) : [],
              });
            });

            self.checkTicketsRules();
          },

          getSalesRules: function (response) {
            const self = $scope.programsDetailOverview;

            const salesRules = (response.data.payload && response.data.payload.salesRuleConfig) || [];
            salesRules.forEach(function (salesRule) {
              const pricepoints = salesRule.pricepoints || {};
              let ruleFilterPricepoints: TODO[] = [];
              let hasRuleFilters = false;

              const hasPricePoints =
                pricepoints && Array.isArray(pricepoints.pricepointInfo) && pricepoints.pricepointInfo.length > 0;

              salesRule.salesRuleType = self.salesRuleTypes[0];

              if (salesRule.hasOwnProperty('ruleFilter')) {
                salesRule.salesRuleType = self.salesRuleTypes[1];

                ruleFilterPricepoints = salesRule.ruleFilter.filters;
                hasRuleFilters = Array.isArray(ruleFilterPricepoints) && ruleFilterPricepoints.length > 0;
              }

              self.salesRules.push({
                timeFrame: self.timeFrames[2],
                limitType: self.limitTypes[1],
                salesRuleType: salesRule.salesRuleType,
                quantity: salesRule.quantity || '0',
                pricepoints: hasPricePoints ? pricepoints.pricepointInfo.sort(self._orderByBusinessRules) : [],
                preventPricepoints: hasRuleFilters ? ruleFilterPricepoints.sort(self._orderByBusinessRules) : [],
              });
            });

            self.checkSalesRules();
          },
        },

        showDiscount: function (discountId) {
          const self = $scope.programsDetailOverview;

          self.showModal = $uibModal.open({
            templateUrl: 'views/application/views/templates/modals/discount/discount.tpl.html',
            size: 'lg',
            controller: 'TemplatesModalsDiscountController',
            resolve: {
              discountId: function () {
                return discountId;
              },
            },
          });
        },

        error: {
          init: function (data, status, headers, config) {},

          getAppliedDiscounts: function (response) {},

          getCouponDiscounts: function (response) {},
          getMembershipDiscounts: function (response) {
            const self = $scope.programsDetailOverview;
            self.membershipLevelsLoaded = true;
          },
          getTicketsRules: function (response) {},
          getSalesRules: function (response) {},
        },

        hasModelResources: function () {
          return this.model.resources && this.model.resources.length > 0;
        },
      };

      $scope.pricingGridOptions = {
        paginate: false,
        multiSelect: false,
        enableRowSelection: false,

        columnDefs: [
          {
            field: 'personType.displayOrder',
            displayName: 'Order',
            visible: false,
          },
          {
            field: 'personType.name',
            displayName: 'Ticket Type',
          },
          {
            field: 'personType.description',
            displayName: 'Description',
          },
          {
            field: 'price',
            displayName: 'Price',
            cellFilter: 'currency',
          },
          {
            field: 'salesChannels[0].enabled',
            displayName: 'Web',
            cellTemplate:
              '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
          },
          {
            field: 'salesChannels[1].enabled',
            displayName: 'POS',
            cellTemplate:
              '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
          },
          {
            field: 'salesChannels[2].enabled',
            displayName: 'Reseller',
            cellTemplate:
              '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-class="{ inactive: grid.appScope.programsDetailOverview.restrictMembers }" data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
          },
          {
            field: 'salesChannels[3].enabled',
            displayName: 'Customer Rep.',
            cellTemplate:
              '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
          },
          {
            field: 'salesChannels[5].enabled',
            displayName: 'Kiosk',
            cellTemplate:
              '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
          },
        ],
      };

      $scope.programsDetailOverview.init();
    },
  ])
  .filter('ruleTypeRead', [
    '$filter',
    function ($filter: IFilterService) {
      return function (input: TODO[], filterType: string) {
        switch (filterType) {
          case 'both':
            return input.filter((item) => item.discountCode && item.pricepoints.length > 0);
          case 'discounts':
            return input.filter((item) => item.discountCode && item.pricepoints.length === 0);
          case 'limits':
            return input.filter((item) => item.pricepoints.length > 0 && !item.discountCode);
          case 'norules':
            return input.filter((item) => !item.discountCode && item.pricepoints.length === 0);

          default:
            return input;
        }
      };
    },
  ]).name;
